import { gql } from '@apollo/client';


export const ADD_OR_UPDATE_RELATIONSHIP_IN_PERSON = gql`
  mutation addOrUpdateRelationshipInPerson($input: AddOrUpdateRelationshipInPersonInput!) {
    addOrUpdateRelationshipInPerson(input: $input) {
     errors
     personUuid
     relationshipUuid
     targetUuid
     relationship {
       id
       person {
         id
       }
       relationshipType {
         id
         name
       }
     }
     target {
       id
     }
    }
  }
`


